<script>
import ContactCard from './contact-card.vue'
import ContactNavbar from './contact-navbar.vue'

export default {
  components: {ContactCard, ContactNavbar},

  data() {
    return {
      contacts: [],
      filteredContacts: [],
      numContacts: 0,
      mmUserId: this.$storage.get('mm_user_id'),
      observed: this.$storage.observed
    }
  },

  computed: {
    contactIds() { return this.observed.contactIds }
  },

  watch: {
    'observed.contactIds': function(newVal, oldVal) {
      if (newVal.length > 0) this.fetchContacts()
    },
  },

  created() {
    if (this.contactIds.length) this.fetchContacts()
  },

  methods: {
    contactUrl(contact) {
      return `/community/${contact.mmid}`
    },

    contactSearchStr(contact) {
      return `${contact.first_name} ${contact.last_name} ${contact.company_name}`.toLocaleLowerCase()
    },

    onSearchChanged: function (search) {
        console.log(search)
        let me = this;
        this.filteredContacts = this.contacts.filter(
          contact => me.contactSearchStr(contact).includes(search.toLowerCase()))
        this.numContacts = this.filteredContacts.length
    },

    onSearchDelete: function () {
      this.search = ''
      this.filteredContacts = this.contacts
      this.numContacts = this.filteredContacts.length
    },

    getNumUnreadMessages: function (contactA, contactB) {
      let na = this.$storage.getDirectChannel(contactA.mmid).numUnreadMessages > 0 || 0
      let nb = this.$storage.getDirectChannel(contactB.mmid).numUnreadMessages > 0 || 0

      // First, prioritize items with unread messages
      if (nb - na === 0) {
        // otherwise compare the dates
        na = this.$storage.getDirectChannel(contactA.mmid).last_post_at
        nb = this.$storage.getDirectChannel(contactB.mmid).last_post_at
      }

      return nb - na
    },

    fetchContacts: function () {
      let me =  this
      let payload = {
        me: me.mmUserId,
        mmids: this.contactIds
      }
      this.$api.post('/community-users/contacts/', payload).then(function(response){
        me.contacts = response.data
        me.contacts.sort((a, b) => me.getNumUnreadMessages(a, b));
        me.filteredContacts = me.contacts
        me.numContacts = me.filteredContacts.length
      })
    },
  },
}
</script>

<template>

  <div>
    <contact-navbar class="mb-1"
      search=""
      @search="onSearchChanged($event)" 
      @delete-search="onSearchDelete" 
    />

    <div v-if="numContacts > 0">
      <small class="text-muted me-1">{{numContacts}} Treffer</small>

      <div class="d-flex flex-wrap align-items-stretch mt-1"
       :class="{'justify-content-between': numContacts > 2, 'justify-content-start': numContacts < 3}">
        <router-link v-for="contact in filteredContacts" :key="contact.id" 
         :to="contactUrl(contact)" class="text-center text-deco-none">
          <contact-card :contact="contact" />
        </router-link>
      </div>

    </div>
    <div v-else>
      <div class="text-center mt-5">-- keine Treffer --</div>
    </div>

  </div>
</template>

<style scoped>

button {
  border: none;
  background: none;
  cursor: pointer;
}

.text-deco-none {
  text-decoration: none;
}

</style>